"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserRsaEncryptionFactory = void 0;

var _basisTheoryJsEncryption = require("@basis-theory/basis-theory-js-encryption");

var _utils = require("../utils");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BrowserRsaEncryptionFactory = /*#__PURE__*/function () {
  function BrowserRsaEncryptionFactory(keyRepo, rsaKeySize) {
    _classCallCheck(this, BrowserRsaEncryptionFactory);

    _defineProperty(this, "provider", 'BROWSER');

    _defineProperty(this, "aesProvider", 'BROWSER');

    _defineProperty(this, "algorithm", 'RSA');

    _defineProperty(this, "_keyRepo", void 0);

    _defineProperty(this, "_rsaKeySize", void 0);

    this._keyRepo = keyRepo;
    this._rsaKeySize = rsaKeySize;
  }

  _createClass(BrowserRsaEncryptionFactory, [{
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(provKeyId, plainTxt) {
        var key, keyPair, pubKey, encrypted;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getKey(provKeyId);

              case 2:
                key = _context.sent;
                keyPair = (0, _basisTheoryJsEncryption.keyIdToRsaKeyPair)(key);
                _context.next = 6;
                return this.loadPublicKey(keyPair.publicKey);

              case 6:
                pubKey = _context.sent;
                _context.next = 9;
                return window.crypto.subtle.encrypt({
                  name: 'RSA-OAEP'
                }, pubKey, // eslint-disable-next-line node/no-unsupported-features/node-builtins
                new TextEncoder().encode(plainTxt).buffer);

              case 9:
                encrypted = _context.sent;
                return _context.abrupt("return", (0, _utils.bufferToBase64)(encrypted));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function encrypt(_x, _x2) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(provKeyId, cipherTxt) {
        var key, keyPair, privKey, decrypted;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getKey(provKeyId);

              case 2:
                key = _context2.sent;
                keyPair = (0, _basisTheoryJsEncryption.keyIdToRsaKeyPair)(key);
                _context2.next = 6;
                return this.loadPrivateKey(keyPair.privateKey);

              case 6:
                privKey = _context2.sent;
                _context2.next = 9;
                return window.crypto.subtle.decrypt({
                  name: 'RSA-OAEP'
                }, privKey, (0, _utils.base64ToBuffer)(cipherTxt));

              case 9:
                decrypted = _context2.sent;
                return _context2.abrupt("return", new TextDecoder().decode(decrypted));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function decrypt(_x3, _x4) {
        return _decrypt.apply(this, arguments);
      }

      return decrypt;
    }()
  }, {
    key: "getKey",
    value: function getKey(providerKeyId) {
      return this._keyRepo.getKey(providerKeyId).catch(function () {
        throw new Error('Error fetching key.');
      });
    }
  }, {
    key: "loadPublicKey",
    value: function loadPublicKey(pem) {
      return window.crypto.subtle.importKey('spki', this.pemToBinary(pem, 'PUBLIC'), (0, _utils.getBrowserRsaParams)(this._rsaKeySize), true, ['encrypt']);
    }
  }, {
    key: "loadPrivateKey",
    value: function loadPrivateKey(pem) {
      return window.crypto.subtle.importKey('pkcs8', this.pemToBinary(pem, 'PRIVATE'), (0, _utils.getBrowserRsaParams)(this._rsaKeySize), true, ['decrypt']);
    }
  }, {
    key: "pemToBinary",
    value: function pemToBinary(pem, label) {
      var lines = pem.split('\n');
      var encoded = '';

      var _iterator = _createForOfIteratorHelper(lines),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;

          /* istanbul ignore next */
          if (line.trim().length > 0 && !line.includes("-BEGIN ".concat(label, " KEY-")) && !line.includes("-END ".concat(label, " KEY-"))) {
            encoded = encoded + line.trim();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return (0, _utils.base64ToBuffer)(encoded);
    }
  }]);

  return BrowserRsaEncryptionFactory;
}();

exports.BrowserRsaEncryptionFactory = BrowserRsaEncryptionFactory;